import { ProductKind } from '../product'

/**
 * Overrides for grouping products in the purchase flow product list.
 *
 * Some products are delivered by the backend under their own `kind` but should
 * be presented as part of another product group instead of a standalone entry.
 * AI photo editing (`AI_PHOTO_EDITING`) is offered as part of `PHOTO` rather
 * than its own product.
 */
export const productKindGroupOverrides: Partial<Record<ProductKind, ProductKind>> = {
  [ProductKind.AI_PHOTO_EDITING]: ProductKind.PHOTO,
}

/**
 * Resolves the product kind under which a product should be grouped in the
 * purchase flow product list. Returns the override target if one is defined,
 * otherwise the kind itself.
 */
export const resolveProductGroupKind = (kind: ProductKind): ProductKind =>
  productKindGroupOverrides[kind] ?? kind
